<ng-container
  #pageDataContainer
  appModifyMoodleLinks
  appModifyAnchorLinks
  appModifyCookieLinks
>
  <app-header
    [generalSettingsData]="generalSettingsData"
    (openSidebar)="toggleSidebar(true)"
  ></app-header>

  <div id="portal-private-component" class="page-container" [ngClass]="{'student-portal' : generalSettingsData?.userDetails?.sessionSiteViewType === 1}">
    <!-- Popup with overlay -->
    <div class="popup-overlay" *ngIf="shouldDisplayPopup"></div>
    <div class="popup-container" *ngIf="shouldDisplayPopup">
      <button class="close-button" (click)="closePopup()">&times;</button>
      <div class="popup__body">
        <h2 class="thanks-block__title">
          {{ popupData?.title }}
        </h2>
        <p class="thanks-block__text" [innerHTML]="popupData?.message | safeHtml"></p>
      </div>
    </div>
    <app-search-block
      *ngIf="generalSettingsData"
      [portalGeneralSettingsData]="
        generalSettingsData.portalGeneralSettingsData
      "
      [modalFullHeight]="fullHeightSearch"
    ></app-search-block>
    <div class="sidebar-overlay" [ngClass]="{ opened: openedSidebar }"></div>

    <app-sidebar
      [generalSettingsData]="generalSettingsData"
      [opened]="openedSidebar"
      (close)="toggleSidebar(false)"
    ></app-sidebar>

    <div class="page-main">
      <div
        *ngIf="generalSettingsData"
        [innerHTML]="
          generalSettingsData.promotedMessagesSection.html | safeHtml
        "
      ></div>
      <div *ngIf="!generalSettingsData">
        <section class="section skeleton section--articles js-art-section">
          <div class="articles-row"></div>
        </section>
      </div>
      <!-- <app-stream *ngIf="showStream"/> -->
      <div class="page-content-wrap">
        <div class="page-content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</ng-container>
